import { getSelectedCategoryName } from '../helpers/get-selected-category-name.js';

function initializeBudget() {
	const categoryName = getSelectedCategoryName(this.formElement);

	const labelElement = this.currentStepElement.querySelector('.quote-request-budget-min-max');

	// The pricing-range treatment already names the category in its
	// "Typical pricing for ..." heading, so keep the label generic there.
	const hasPricingRange = this.currentStepElement.querySelector('.quote-request-pricing-range');

	if (categoryName && !hasPricingRange) {
		labelElement.dataset.originalText = labelElement.textContent;
		labelElement.textContent = `What is your budget range for the ${categoryName}?`;
	} else if (labelElement.dataset.originalText) {
		labelElement.textContent = labelElement.dataset.originalText;
	}
}

export {
	initializeBudget
}
